<template>
    <div>
        <NewsFinderAndCreator
            :key="componentRefreshKey"
            :isNeedCreate="true"
            :changed-item="changedItem"
            :additionalGetParameter="additionalGetParameter"
            :typeOfTableFilter="$route.params.category ? '' : 'news'"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import NewsFinderAndCreator from '@/components/news/NewsFinderAndCreator.vue'

    export default {
        components: {
            NewsFinderAndCreator,
        },
        props: {
            changedItem: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                additionalGetParameter: '',
                componentRefreshKey: 0,
            }
        },
        computed: {
            ...mapGetters("auth", ["currentUser"]),
        },
        created() {
            this.additionalGetParameterChanger()
        },
        watch: {
            '$route.path'() {
                this.additionalGetParameterChanger()
            }
        },
        methods: {
            additionalGetParameterChanger() {
                if (this.$route.params.category) {
                    this.additionalGetParameter = `&category=${this.$route.params.category}`
                } else {
                    this.additionalGetParameter = ''
                }
                this.componentRefreshKey += 1
            },
        }
    }
</script>
